export const getters = {
  getOrder: (state) => {
    return state.order_list;
  },
  getProfile: (state) => {
    return state.profile;
  },

  isAuthenticated: (state) => {
    return state.IsAuthenticated;
  },

  getArtists: (state) => {
    return state.artists;
  },

  getArtistsCount: (state) => {
    return state.artists_count;
  },

  getArt: (state) => {
    return state.art;
  },

  getExploreArt: (state) => {
    return state.explore_art;
  },

  getExhibitionList: (state) => {
    return state.exhibition_list;
  },

  getArtistProfile: (state) => {
    return state.artistProfile;
  },

  getFeaturedArtistProfile: (state) => {
    return state.featured_artists;
  },

  getWishList: (state) => {
    return state.wishList;
  },

  getIsWishListed: (state) => (product_id) => {
    let wished_product = state.wishList.filter(
      (product) => product.wish_product.id == product_id
    );

    if (wished_product.length != 0) {
      return true;
    } else {
      return false;
    }
  },

  getArtistProducts: (state) => {
    return state.artistProducts;
  },

  getHomePageContent: (state) => {
    return state.homePageContent;
  },

  getMostSold: (state) => {
    return state.mostSoldArt;
  },

  getRealtedProducts: (state) => (artist_id) => {
    return state.realtedProducts.filter(
      (product) => product.artist.id == artist_id
    );
  },

  getCategoryInfoById: (state) => (category_id) => {
    return state.categoryInfo.filter(
      (category) => category.id == category_id
    )[0];
  },

  getSubCategoryProducts: (state) => (json_data) => {
    let parent_category_products = state.subCategoryProducts.filter(
      (product) => product.parent_category.id == json_data.parent_category_id
    );

    if (json_data.sub_category_id == 0) {
      return parent_category_products;
    } else {
      return parent_category_products.filter(
        (product) => product.sub_category.id == json_data.sub_category_id
      );
    }
  },

  getCategories: (state) => {
    return state.categories;
  },

  getArtStoriesList: (state) => {
    return state.art_stories_list;
  },

  getArtStory: (state) => {
    return state.art_story;
  },

  getFeaturedArtStoriesList: (state) => {
    return state.featured_art_stories_list;
  },

  getCartList: (state) => {
    return state.cart_list;
  },

  getAddressList: (state) => {
    return state.address_list;
  },

  // Get Cart from Local Storage

  get_cart_locally() {
    if (localStorage.getItem("cart"))
      return JSON.prase(localStorage.getItem("cart"));
    else return null;
  },
};
